import { useEffect, useState } from 'react';

import api from '@/lib/api';
import type { UserSupportAttachmentDTO } from '@klaro7/shared-types';

export function SupportUserAttachment({
  messageId,
  index,
  meta,
}: {
  messageId: string;
  index: number;
  meta: UserSupportAttachmentDTO;
}) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [pdfError, setPdfError] = useState(false);
  const isImage = meta.mimetype.startsWith('image/');

  useEffect(() => {
    let revoked = false;
    let url: string | null = null;
    if (!isImage) return;
    api
      .get(`/user-support/attachments/${messageId}/${index}`, { responseType: 'blob' })
      .then((res) => {
        if (revoked) return;
        url = URL.createObjectURL(res.data as Blob);
        setObjectUrl(url);
      })
      .catch(() => {});
    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [messageId, index, isImage]);

  const openPdf = async () => {
    try {
      const res = await api.get(`/user-support/attachments/${messageId}/${index}`, {
        responseType: 'blob',
      });
      const url = URL.createObjectURL(res.data as Blob);
      window.open(url, '_blank', 'noopener');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      setPdfError(true);
    }
  };

  if (isImage) {
    return objectUrl ? (
      <img src={objectUrl} alt={meta.filename} className="mt-1 max-h-48 rounded-lg object-cover" />
    ) : (
      <div className="mt-1 h-24 w-32 animate-pulse rounded-lg bg-neutral-200" />
    );
  }

  return (
    <div className="mt-1 flex flex-col gap-0.5">
      <button
        onClick={openPdf}
        className="flex items-center gap-2 rounded-lg bg-white/20 px-2 py-1 text-[12px] underline"
      >
        📎 {meta.filename}
      </button>
      {pdfError && <span className="text-[10px] text-red-600">Impossibile aprire il file</span>}
    </div>
  );
}
